(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["systems-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-is-systems]');
    if (!root) return;

    var tabs = root.querySelectorAll('[data-systems-tab]');
    var rows = root.querySelectorAll('[data-systems-row]');
    if (!tabs.length || !rows.length) return;

    var setActive = function (handle) {
      tabs.forEach(function (tab) {
        tab.classList.toggle('is-active', tab.getAttribute('data-systems-tab') === handle);
      });
    };

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              setActive(entry.target.getAttribute('data-systems-row'));
            }
          });
        },
        { rootMargin: '-40% 0px -55% 0px', threshold: 0 }
      );
      rows.forEach(function (row) {
        observer.observe(row);
      });
    }

    root.querySelectorAll('a[href^="#sys-"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
